var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tabs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.27373675e-13,3 C-2.27373675e-13,1.40231912 1.24891996,0.0963391206 2.82372721,0.00509269341 L3,0 L19,0 C20.6568542,0 22,1.34314575 22,3 L22.0009007,4.17102423 C23.1656226,4.58311485 24,5.69411778 24,7 L24,21 C24,22.6568542 22.6568542,24 21,24 L3,24 C1.34314575,24 -2.27373675e-13,22.6568542 -2.27373675e-13,21 L-2.27373675e-13,3 Z M2,21 C2,21.5128358 2.38604019,21.9355072 2.88337887,21.9932723 L3,22 L21,22 C21.5128358,22 21.9355072,21.6139598 21.9932723,21.1166211 L22,21 L22,7 C22,6.48716416 21.6139598,6.06449284 21.1166211,6.00672773 L21,6 L8,6 L8,3 C8,2.48716416 7.61395981,2.06449284 7.11662113,2.00672773 L7,2 L3,2 L2.88337887,2.00672773 C2.42429701,2.06004937 2.06004937,2.42429701 2.00672773,2.88337887 L2,3 L2,21 Z M13,2 L9.82932572,2.00008893 C9.93985718,2.31284272 10,2.64939781 10,3 L10,4 L14,4 L14,3 C14,2.48716416 13.6139598,2.06449284 13.1166211,2.00672773 L13,2 Z M19,2 L15.8293257,2.00008893 C15.9398572,2.31284272 16,2.64939781 16,3 L16,4 L20,4 L20,3 C20,2.48716416 19.6139598,2.06449284 19.1166211,2.00672773 L19,2 Z",
    id: "Tabs"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabs);
export default __webpack_public_path__ + "static/media/Tabs.3f9123d7.svg";
export { ForwardRef as ReactComponent };